import { render, staticRenderFns } from "./ReceiverOrderListPage.vue?vue&type=template&id=4cd4e85c&"
import script from "./ReceiverOrderListPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverOrderListPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverOrderListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports